import { useSelector } from 'react-redux'

import { skipToken } from '@reduxjs/toolkit/query'

import { getSelectedClientId } from '../../../../data/lyraTherapy/clientSelectors'
import { useGetCareTimelineSessionsQuery } from '../careTimelineApi'

export const useCareTimelineSessionsData = (opts?: Parameters<typeof useGetCareTimelineSessionsQuery>[1]) => {
  const clientId = useSelector(getSelectedClientId)
  return useGetCareTimelineSessionsQuery(clientId ? { patientId: clientId } : skipToken, opts)
}
